import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-gradient-to-br from-indigo-600 via-purple-600 to-pink-500 text-white">
      <div className="max-w-7xl mx-auto px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          <div>
            <h3 className="text-2xl font-bold mb-4">Pavane</h3>
            <p className="text-white/90 text-sm leading-relaxed">
              파반느는 일러스트레이터, 디자이너, 작가 등 다양한 예술가들이 모여있는 크리에이티브 에이전시입니다.
            </p>
          </div>

          <div>
            <h4 className="font-semibold mb-4 text-lg">아티스트</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/illustrators" className="text-sm text-white/90 hover:text-white transition-colors">
                  Illustrators
                </Link>
              </li>
              <li>
                <Link to="/designers" className="text-sm text-white/90 hover:text-white transition-colors">
                  Designers
                </Link>
              </li>
              <li>
                <Link to="/writers" className="text-sm text-white/90 hover:text-white transition-colors">
                  Writers
                </Link>
              </li>
              <li>
                <Link to="/painters" className="text-sm text-white/90 hover:text-white transition-colors">
                  Painters
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold mb-4 text-lg">회사</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/about" className="text-sm text-white/90 hover:text-white transition-colors">
                  About
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-sm text-white/90 hover:text-white transition-colors">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold mb-4 text-lg">팔로우하기</h4>
            <div className="flex gap-4">
              <a href="https://www.instagram.com/agencypavane/" target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center bg-white/20 rounded-full hover:bg-white/30 transition-colors cursor-pointer">
                <i className="ri-instagram-line text-xl"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-white/20 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-sm text-white/80">
            © 2025 Pavane Agency. All rights reserved.
          </p>
          <a 
            href="https://readdy.ai/?ref=logo" 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-sm text-white/80 hover:text-white transition-colors"
          >
            Powered by Readdy
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
